import { render, staticRenderFns } from "./supplyModal.vue?vue&type=template&id=0187233e&scoped=true"
import script from "./supplyModal.vue?vue&type=script&lang=js"
export * from "./supplyModal.vue?vue&type=script&lang=js"
import style0 from "./supplyModal.vue?vue&type=style&index=0&id=0187233e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187233e",
  null
  
)

export default component.exports